// @core/api/endpoints/product/update_product_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductCategoryResponse,
  UpdateProductCategoryRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Update product category
 * Updates a product category's name, description, icon, or display order.
 */
export async function UpdateProductCategory(
  category_id: string,
  data: UpdateProductCategoryRequest,
  options?: RequestOptions
): Promise<ProductCategoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.put<ProductCategoryResponse>(requestPath, data, requestOptions);
}
